import { Component } from '@angular/core';
import { ContainerSize } from '@freelancer/ui/container';
import {
  FontColor,
  FontWeight,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';

@Component({
  selector: 'app-freightlancer-landing-page-learn-more-blade',
  template: `
    <fl-container class="LearnMoreBlade" [size]="ContainerSize.DESKTOP_XLARGE">
      <fl-grid>
        <fl-col class="LearnMoreBlade-owners" [col]="12" [colTablet]="6">
          <fl-link flTrackingLabel="LearnMoreOwners" [disabled]="true">
            <fl-bit class="LearnMoreBlade-links">
              <fl-text
                i18n="Learn more link text"
                [color]="FontColor.LIGHT"
                [size]="TextSize.SMALL"
                [weight]="FontWeight.BOLD"
              >
                Learn more for
              </fl-text>
              <fl-text
                i18n="Freight owners link text"
                [color]="FontColor.LIGHT"
                [size]="TextSize.XXLARGE"
                [textTransform]="TextTransform.UPPERCASE"
                [weight]="FontWeight.BOLD"
              >
                Freight Owners
              </fl-text>
            </fl-bit>
          </fl-link>
        </fl-col>
        <fl-col class="LearnMoreBlade-operators" [col]="12" [colTablet]="6">
          <fl-link flTrackingLabel="LearnMoreOperators" [disabled]="true">
            <fl-bit class="LearnMoreBlade-links">
              <fl-text
                i18n="Learn more link text"
                [color]="FontColor.LIGHT"
                [size]="TextSize.SMALL"
                [weight]="FontWeight.BOLD"
              >
                Learn more for
              </fl-text>
              <fl-text
                i18n="Transport operators link text"
                [color]="FontColor.LIGHT"
                [size]="TextSize.XXLARGE"
                [textTransform]="TextTransform.UPPERCASE"
                [weight]="FontWeight.BOLD"
              >
                Transport Operators
              </fl-text>
            </fl-bit>
          </fl-link>
        </fl-col>
      </fl-grid>
    </fl-container>
  `,
  styleUrls: ['freightlancer-landing-page-learn-more-blade.component.scss'],
})
export class FreightlancerLandingPageLearnMoreBladeComponent {
  ContainerSize = ContainerSize;
  FontColor = FontColor;
  FontWeight = FontWeight;
  TextSize = TextSize;
  TextTransform = TextTransform;
}
